import { useState } from 'react'
import { Form, Input, Select, DatePicker } from "antd";
import { useLocation } from "wouter";
import { useModal } from "../../../customHooks/useModal";
import iconSuccess from '../../../assets/iconProfileCreate.svg'
import FormTitle from "../../Atoms/FormTitle/FormTitle";
import InputFormContainer from "../../Atoms/InputFormContainer/InputFormContainer";
import Button from '../../Atoms/Button/Button';
import Modal from '../../Organisms/Modal/Modal';
import './CreateProduct.scss'
import HeaderTitle from '../../Molecules/HeaderTitle/HeaderTitle';
const { Option } = Select;

const CreateProduct = () => {
  const [isOpenModal, openModal, closeModal] = useModal()
  const [form] = Form.useForm();
  const [, setLocation ] = useLocation();
  const [prevFile, setPrevFile] = useState([])

  const sendForm = (e) => {
    console.log(e); // Aqui el objeto con los valores del formulario
    openModal(true) // Si se envia el formulario correctamente, se muestra el modal
  };

  // Limpiar formulario
  const clearForm = () => {
    form.resetFields()
    setPrevFile([])
    closeModal()
  }

   // Fecha
  const onChange = (e) => {
    console.log(e); 
  };

  // Subir fotos
  const handleUpload = (e) => {
    for(let propiedadItarable of e.target.files) {
      if(propiedadItarable.type === 'image/jpeg' || propiedadItarable.type === 'image/png') {
        const reader = new FileReader();
        reader.onload = () => {
          if(reader.readyState === 2) {
            setPrevFile(prevFile.concat(reader.result))
          }
        }
        reader.readAsDataURL(propiedadItarable)
      } else if(propiedadItarable.type === 'application/pdf') {
        setPrevFile(prevFile.concat(' https://s1.eestatic.com/2018/05/02/actualidad/actualidad_304233531_130193551_1024x576.jpg'))
      } else {
        console.log('no es imagen ni pdf, colocar error aquí')
      }
    }
  }

  return (
    <div className="nd-grid manage-product">
     <HeaderTitle headerText="Crear producto" />
      <div className="box l-pxy-30 mt-30">
        <div>
          <Form onFinish={sendForm}  form={form} >
            <div>
              <FormTitle text="Datos del producto" />

              <InputFormContainer label="Nombre:" indentificador="name">
                <Form.Item name="name" rules={[{required: true, message: "Por favor ingresa el nombre del producto"}]}>
                  <Input size="large" placeholder="Nombre del producto" />
                </Form.Item>
              </InputFormContainer>

              <InputFormContainer label="Descripción:" indentificador="description">
                <Form.Item name="description" rules={[{required: true, message: "Por favor ingresa la descripción del producto"}]}>
                  <Input size="large" placeholder="Descripción del producto" />
                </Form.Item>
              </InputFormContainer>
            </div>

            <div className="nd-grid m-grid-2">
              <FormTitle customClass="m-cols-2" text="Clasificación o tipo de producto" />

              <InputFormContainer label="Categoría principal:" indentificador="category">
                <Form.Item name="category" rules={[{ required: true, message: "Categoria" }]}>
                  <Select placeholder="Categoria" size="large">
                    <Option value={"telecom"}>Telecom</Option>
                  </Select>
                </Form.Item>
              </InputFormContainer>

              <InputFormContainer label="Sub categoría:" indentificador="sub_category">
                <Form.Item name="sub_category" rules={[{ required: true, message: "Sub Categoría" }]} >
                  <Select placeholder="Sub Categoría" size="large">
                    <Option value={"servicios_de _internet"}>Servicios de internet</Option>
                  </Select>
                </Form.Item>
              </InputFormContainer>

              <InputFormContainer spanTwo label="Otras carácterísticas (tecnología, filtros, etiquetas):" indentificador="otherCategories">
                <Form.Item name="otherCategories" rules={[{ required: true, message: "Otras carácterísticas:" }]}>
                  <Select placeholder="Otras carácterísticas:" mode="multiple" size="large">
                    <Select.Option value="Fibra Óptica" key={1} >Fibra Óptica</Select.Option>
                    <Select.Option value="Satelital" key={2}>Satelital</Select.Option>
                    <Select.Option value="Microondas" key={3}>Microondas</Select.Option>
                    <Select.Option value="HFC" key={4}>HFC</Select.Option>
                    <Select.Option value="Cobre" key={5}>Cobre</Select.Option>
                    <Select.Option value="Antena" key={6}>Antena</Select.Option>
                  </Select>
                </Form.Item>
              </InputFormContainer>
            </div>

            <div className="nd-grid m-grid-2 l-grid-3">
              <FormTitle customClass="m-cols-2 l-cols-3" text="Presentación y condiciones de contracción" />

              <InputFormContainer label="Fecha de inicio:" indentificador="initDate" >
                <Form.Item name="initDate" rules={[{required: true, message: "Debe indicar la fecha de inicio"}]}>
                  <DatePicker size="large" placeholder="Fecha de inicio" onChange={onChange} />
                </Form.Item>
              </InputFormContainer>

              <InputFormContainer label="Moneda:" indentificador="currency">
                <Form.Item name="currency" rules={[{required: true, message: "Moneda"}]}>
                  <Select size="large" placeholder="Moneda">
                    <Option value="Moneda:">USD</Option>
                  </Select>
                </Form.Item>
              </InputFormContainer>

              <InputFormContainer label="Fecha de finalización:" indentificador="finalitationDate">
                <Form.Item name="finalitationDate" rules={[{required: true, message: "Debe indicar la fecha de finalización:"}]}>
                  <DatePicker size="large" placeholder="Fecha de finalización" onChange={onChange} />
                </Form.Item>
              </InputFormContainer>

              <InputFormContainer label="Indique nombre de la presentación:" indentificador="name_presentation">
                <Form.Item name="name_presentation" rules={[{required: true, message: "Por favor ingresa el nombre de la presentación"}]}>
                  <Input size="large" placeholder="Nombre de la presentación" />
                </Form.Item>
              </InputFormContainer>

              <InputFormContainer label="Precio:" indentificador="price">
                <Form.Item name="price" rules={[{required: true, message: "Por favor ingresa el Precio"}]}>
                  <Input size="large" placeholder="Precio" />
                </Form.Item>
              </InputFormContainer>

              <InputFormContainer label="Inventario:" indentificador="inventary">
                <Form.Item name="inventary" rules={[{required: true, message: "Por favor ingresa el Inventario"}]}>
                  <Input size="large" placeholder="Inventario" />
                </Form.Item>
              </InputFormContainer>
            </div>
            
            <div className="nd-grid m-grid-2">
              <FormTitle customClass="m-cols-2" text="Limitaciones" />

              <InputFormContainer label="Área geográfica o cobertura:" indentificador="geographic">
                <Form.Item name="geographic" rules={[{required: true, message: "Por área geográfica o cobertura"}]}>
                  <Select size="large" placeholder="Área geográfica o cobertura:">
                    <Option value="Por área geográfica o cobertura">Por área geográfica o cobertura</Option>
                    </Select>
                </Form.Item>
              </InputFormContainer>

              <InputFormContainer label="por estado:" indentificador="for_state">
                <Form.Item name="for_state" rules={[{required: true, message: "Disponible por estado"}]}>
                  <Select size="large" placeholder="Limitaciones:">
                    <Option value="Disponible por estado">Disponible por estado</Option>
                    </Select>
                </Form.Item>
              </InputFormContainer>

              <InputFormContainer label="Estado:" indentificador="state">
                <Form.Item name="state" rules={[{required: true, message: "Estado"}]}>
                  <Select size="large" placeholder="Estado:">
                    <Option value="Estado">Estado</Option>
                    </Select>
                </Form.Item>
              </InputFormContainer>

              <InputFormContainer label="Municipios:" indentificador="municipalities">
                <Form.Item name="municipalities" rules={[{required: true, message: "Municipios"}]}>
                  <Select size="large" placeholder="Municipios:">
                    <Option value="Estado">Municipios</Option>
                    </Select>
                </Form.Item>
              </InputFormContainer>

              <FormTitle customClass="m-cols-2" text="Urbanizaciones" />

              <InputFormContainer spanTwo label="Urbanizaciones:" indentificador="urbanizations">
                <Form.Item name="urbanizations" rules={[{required: true, message: "Indicar urbanizaciones"}]}>
                  <Input size="large" placeholder="Indicar urbanizaciones" />
                </Form.Item>
              </InputFormContainer>
            </div>

            <p className="link">Agregar otra presentación</p>

            <div>
              <FormTitle customClass="m-cols-2" text="Fotos o imágenes del producto" />

              <input 
                type="file" 
                onChange={e => handleUpload(e)}
                multiple
                className="input-file-product"
                accept=".png, .jpg, .jpeg, .pdf, image/jpeg, image/jpg, image/png, image/x-png"
                id="input-file-product"
              />
            </div>

            <label className="input-file-product-fake" htmlFor="input-file-product">
              <span className="button primary s-large m-auto">Sube o arroja los archivos</span>
              <p className="source-16">Solo puedes subir un máximo de 5 archivos en los formatos “png”, “jpg” o “pdf” y un peso de 2mb.</p>
            </label>

            {
              prevFile.map(img => 
                <div className="prev-image mt-20" key={img}>
                  <img className="prev-image_img" src={img} alt="prev"  />
                  <div className="prev-image_bar"></div>
                  <p className="source-16">100% cargado</p>
                </div>
              )
            }

            <div className="buttons-container m-cols-2 mt-30">
              <Button content="Listo, crear campaña" customClass="s-large m-auto" type="primary" htmlType="submit" />
              <span className="button primary outline s-large m-auto">Ir al paso anterior</span>
            </div>
          </Form>
        </div>
      </div>

      <Modal
        isOpenModal={isOpenModal}
        closeModal={closeModal}
        iconModal={iconSuccess}
        titleModal="¡Listo!" 
        subTitleModal="Has creado el producto correctamente ¿Qué quieres hacer ahora?"
      >
       <div className="buttons-container center">
          <Button content="Crear otro producto" customClass="s-large m-auto" type="primary" clickHandler={() => clearForm()} />
          <Button content="Gestionar productos" customClass="s-large m-auto" type="primary outline" clickHandler={() => setLocation('/productos/gestionar')}/>   
        </div>
      </Modal>
    </div>
  )
}

export default CreateProduct
